export async function loadScript(url: string) {
	return new Promise((resolve, reject) => {
		const scriptElement = document.createElement("script");
		scriptElement.setAttribute("type", "text/javascript");
		scriptElement.src = url;
		scriptElement.onload = function () {
			resolve(true);
			scriptElement.parentNode?.removeChild(scriptElement);
		};
		scriptElement.onerror = function () {
			reject("Fehler beim Laden des Scriptes");
			scriptElement.parentNode?.removeChild(scriptElement);
		};
		document.body.appendChild(scriptElement);
	});
}

const inAppBrowserIndicators = [
	"fb_iab",
	"fban",
	"fbav",
	"gsa", // GSA = Google Search App
	"instagram",
	"linkedinapp",
	"messenger",
	"pinterest",
	"snapchat",
	"bytelocale", // tiktok on Android
	"bytedancewebview", // tiktok on iOS
	"twitter",
	"whatsapp",
	"youtube",
];

export function isInAppBrowser() {
	const lowerCasedUA = (navigator.userAgent || "").toLowerCase();
	return inAppBrowserIndicators.some((indicator) => lowerCasedUA.includes(indicator));
}
